import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'; // 引入 store 实例
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';



// import { component } from 'vue/types/umd'

Vue.use(VueRouter)
Vue.use(ElementUI)

const routes = [
  {
    path: "/",
    name: "home",
    redirect: "/portal", //登录重定向
  },
  {
    path: "/portal",
    name: "portal",
    meta: {
      isAuth: false,
    },
    component: () => import("@/views/homepage/portal.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    meta: {
      isAuth: false,
    },
    component: () => import("@/views/homepage/contact.vue"),
  },
  {
    path: "/login",
    name: "login",
    meta: {
      isAuth: false,
    },
    component: () => import("@/views/login/index.vue"),
  },
  //注册
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register/index.vue"),
    meta: {
      isAuth: false,
    },
  },
  {
    path: "/license",
    name: "license",
    component: () => import("@/views/agreements/license.vue"),
    meta: {
      isAuth: false,
    },
  },
  {
    path: "/security",
    name: "security",
    component: () => import("@/views/agreements/security.vue"),
    meta: {
      isAuth: false,
    },
  },
  {
    path: "/userAG",
    name: "userAG",
    component: () => import("@/views/agreements/userAG.vue"),
    meta: {
      isAuth: false,
    },
  },
{
    path: "/identity",
    name: "identity",
    component: () => import("@/views/agreements/identity.vue"),
    meta: {
      isAuth: false,
    },
  },
  {
    path: "/antifraud",
    name: "antifraud",
    component: () => import("@/views/agreements/antifraud.vue"),
    meta: {
      isAuth: false,
    },
  },

  //找回密码
  {
    path: "/findPassword",
    name: "findPassword",
    component: () => import("@/views/02third-level-router/findPassword.vue"),
    meta: {
      isAuth: false,
    },
  },
  //错误
  {
    path: "/error",
    name: "error",
    component: () => import("@/views/error.vue"), //
    props: (route) => ({
      message: route.query.message,
      status: route.query.status,
    }),
  },
  {
    path: "/main",
    name: "main",
    redirect: "/main/Staticpurchase", //登录重定向
    meta: {
      isAuth: true,
    },
    component: () => import("@/views/home.vue"),
    children: [
      // 静态购买
      {
        path: "Staticpurchase",
        name: "静态购买",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/Staticpurchase.vue"),
        redirect: "/main/Staticpurchase/static", //登录重定向
        children: [
          //机房节点A区
          {
            path: "static",
            name: "精品静态",
            meta: {
              isAuth: true,
            },
            component: () => import("@/views/Static/nodeA.vue"),
          },
          //定制B购买
          {
            path: "customization",
            name: "定制节点",
            meta: {
              isAuth: true,
            },
            component: () => import("@/views/01family/high.vue"),
          },
          //定制A购买
          {
            path: "customizationA",
            name: "定制节点A",
            meta: {
              isAuth: true,
            },
            component: () => import("@/views/homepage/Familycustomization.vue"),
          },
          //家庭节点购买
          {
            path: "family",
            name: "家庭节点",
            meta: {
              isAuth: true,
            },
            component: () => import("@/views/homepage/Familynode.vue"),
          },
          //家庭线路A购买
          {
            path: "familyLineA",
            name: "家庭节点A",
            meta: {
              isAuth: true,
            },
            component: () => import("@/views/homepage/FamilyLineANode.vue"),
          },
          //机房节点B区
          {
            path: "static2",
            name: "机房节点B区",
            meta: {
              isAuth: true,
            },
            component: () => import("@/views/Static/nodeB.vue"),
          },
        ],
      },

      //续费/切换
      {
        path: "change",
        name: "节点操作",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/02third-level-router/change.vue"),
      },
      //切换记录
      {
        path: "changRecord",
        name: "切换记录",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/02third-level-router/changRecord.vue"),
      },

      // //家庭定制A购买
      // {
      //   path: "familycustomization",
      //   name: "定制节点",

      //   meta: {
      //     isAuth: true,
      //   },
      //   component: () => import("@/views/homepage/Familycustomization.vue"),
      // },

      //多账号搜索
      {
        path: "multiple",
        name: "多账号搜索",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/multiSearch.vue"),
      },
       {
        path: "multiple2",
        name: "多账号搜索",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/multiSearch2.vue"),
      },
      //IP痕迹库
      {
        path: "trace",
        name: "IP痕迹库",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/trace.vue"),
      },

      // 账号管理
      {
        path: "account",
        name: "账户A",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/Account.vue"),
      },
      //
      // {
      //   path: "accountB",
      //   name: "节点信息",
      //   meta: {
      //     isAuth: true,
      //   },
      //   component: () => import("@/views/homepage/AccountB.vue"),
      // },
      {
        path: "userNodes", // 路径保持不变，通过查询参数传递筛选条件
        name: "节点信息",
        meta: {
          isAuth: true,
          //文档化支持的筛选参数，方便团队协作
          supportFilter: {
            key: "filter", // 参数名
            values: ["all", "seven","expired"], // 支持的参数值：all=全部，seven=即将到期,zero=已到期
            default: "all", // 默认值（组件内可 fallback 到该值）
          },
        },
        // 关键：通过 props 将路由查询参数映射到组件 props，避免组件内重复写 $route.query
        props: (route) => ({
          // 从路由查询参数中获取 filter 值，默认值设为 'all'（展示全部）
          filterType: route.query.filter || "all",
        }),
        component: () => import("@/views/homepage/AccountB.vue"),
      },
      {
        path: "homeIndex",
        name: "总览",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/user.vue"),
      }, // 在路由配置中添加
      {
        path: "announcements",
        name: "公告",
        // component: AnnouncementList,
        meta: {
          title: "公告列表",
          isAuth: true,
        },
        component: () => import("@/views/homepage/AnnouncementList.vue"),
      },

      // //账单
      // {
      //   path: 'news',
      //   name: '消息提醒',
      //   meta: {
      //     isAuth: true
      //   },
      //   component: () => import('@/views/homepage/news.vue')
      // },
      //个人信息
      {
        path: "person",
        name: "个人信息",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/billView.vue"),
      },
      //修改密码
      {
        path: "binding",
        name: "修改密码",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/phoneBinding.vue"),
      },
      //身份认证
      {
        path: "identity",
        name: "身份认证",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/identity.vue"),
      },
      //在线充值
      // {
      //   path: 'onlineRecharge',
      //   name: '在线充值',
      //   meta: {
      //     isAuth: true
      //   },
      //   component: () => import('@/views/homepage/OnlineRecharge.vue')
      // },
      //充值记录
      // {
      //   path: 'statement',
      //   name: '充值记录',
      //   meta: {
      //     isAuth: true
      //   },
      //   component: () => import('@/views/homepage/statement.vue')
      // },
      //消息提醒
      {
        path: "news",
        name: "消息提醒",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/news.vue"),
      },
      // //个人信息
      // {
      //   path: 'person',
      //   name: '个人信息',
      //   meta: {
      //     isAuth: true
      //   },
      //   component: () => import('@/views/homepage/person.vue')
      // },
      //推广
      {
        path: "promote",
        name: "推广",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/promote.vue"),
      },
      //在线充值
      {
        path: "Recharge",
        name: "在线充值",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/OnlineRecharge.vue"),
      },
      {
        path: "Withdraw",
        name: "提现",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/withdraw.vue"),
      },
      //充值记录
      {
        path: "statement",
        name: "充值记录",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/statement.vue"),
      },
      //消费记录
      {
        path: "record",
        name: "消费记录",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/record.vue"),
      },

      //帮助
      {
        path: "help",
        name: "Help",
        component: () => import("@/views/help/helpView.vue"),
        redirect: "/main/help/ques", // 添加这行，默认重定向到ques页面
        meta: {
          isAuth: true,
        },
        children: [
          {
            path: "ques",
            name: "帮助文档&常见问题",
            component: () => import("@/views/help/helpQues.vue"),

            meta: {
              title: "常见问题",
            },
            children: [
              {
                path: "sstap",
                name: "SStapHelp",
                component: () => import("@/views/help/SstapComp.vue"),
                meta: {
                  title: "Sstap",
                },
              },
              {
                path: "/help/proxifier",
                name: "ProxifierHelp",
                component: () => import("@/views/help/ProxifierComp.vue"),
                meta: {
                  title: "Proxifier",
                },
              },
              {
                path: "NB4A",
                name: "NB4AHelp",
                component: () => import("@/views/help/NB4A.vue"),
                meta: {
                  title: "Proxifier",
                },
              },
            ],
          },
          // {
          //   path: "/notice",
          //   name: "公告",
          //   component: () => import("@/views/help/noticeList.vue"),
          //   meta: {
          //     title: "公告",
          //   },
          // },
          // {
          //   path: "download",
          //   name: "下载",
          //   component: () => import("@/views/help/downloadView.vue"),
          //   meta: {
          //     title: "下载",
          //   },

          // },
          {
            path: "/download/sstap",
            name: "SStap",
            component: () => import("@/views/download/SstapComp.vue"),
            meta: {
              title: "Sstap",
            },
          },
          {
            path: "/download/proxifier",
            name: "Proxifier",
            component: () => import("@/views/download/ProxifierComp.vue"),
            meta: {
              title: "Proxifier",
            },
          },
          {
            path: "/download/v2rayNG",
            name: "v2rayNG",
            component: () => import("@/views/download/v2rayNG.vue"),
            meta: {
              title: "v2rayNG",
            },
          },
          {
            path: "/download/robot",
            name: "robot",
            component: () => import("@/views/download/robotComp.vue"),
            meta: {
              title: "robot",
            },
          },
          {
            path: "/download/postern",
            name: "Postern",
            component: () => import("@/views/download/PosternCompt.vue"),
            meta: {
              title: "Postern",
            },
          },
          {
            path: "/download/NB4A",
            name: "NB4A",
            component: () => import("@/views/download/NB4A.vue"),
            meta: {
              title: "NB4A",
            },
          },
          {
            path: "area",
            name: "地区",
            component: () => import("@/views/help/areaView.vue"),
            meta: {
              title: "地区",
            },
          },
        ],
      },
      //下载
      {
        path: "download",
        name: "下载",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/download.vue"),
      },
      //联系我们
      {
        path: "connect",
        name: "联系我们",
        meta: {
          isAuth: true,
        },
        component: () => import("@/views/homepage/connect.vue"),
      },
    ],
  },
];



const createRouter = () => new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

const router = createRouter()

// 导航队列控制系统
const pendingNavigation = {
  current: null,
  isHistoryNavigation: false,
  cancel() {
    if (this.current) {
      this.current.cancelled = true
      this.current = null
    }
  },
  start(route) {
    this.cancel()
    this.current = { route, cancelled: false }
    return this.current
  },
  finish() {
    if (this.current) this.current = null
  },
  isCancelled() {
    return this.current ? this.current.cancelled : false
  }
}

// 路由防抖控制
const navigationDebounce = (() => {
  let lastTime = 0
  let lastPath = ''

  return (fromPath, toPath) => {
    const now = Date.now()
    const navigationKey = `${fromPath}-${toPath}`

    if (lastPath === navigationKey && now - lastTime < 300) {
      return true // 需要防抖
    }

    lastTime = now
    lastPath = navigationKey
    return false // 不需要防抖
  }
})()

// 导航冷却期 - 优化以减少导航取消错误
const navigationCooldown = (() => {
  let lastNavigationTime = 0
  const COOLDOWN_PERIOD = 100 // 毫秒
  let pendingCallbacks = []
  let timeoutId = null

  return {
    shouldDelay() {
      const now = Date.now()
      const timeSinceLastNav = now - lastNavigationTime
      return timeSinceLastNav < COOLDOWN_PERIOD
    },

    executeWithDelay(callback) {
      if (this.shouldDelay()) {
        // 将回调添加到队列
        pendingCallbacks.push(callback)
        
        // 如果没有等待执行的超时，创建一个
        if (!timeoutId) {
          timeoutId = setTimeout(() => {
            // 执行队列中最后一个回调，忽略其他的
            const lastCallback = pendingCallbacks.pop()
            if (lastCallback) lastCallback()
            
            // 清空队列和超时ID
            pendingCallbacks = []
            timeoutId = null
            
            // 更新上次导航时间
            lastNavigationTime = Date.now()
          }, COOLDOWN_PERIOD)
        }
        return
      }
      
      // 无需延迟，直接执行
      lastNavigationTime = Date.now()
      callback()
    }
  }
})()

// 路由参数校验
const validateRouteParams = (to) => {
  // 根据不同路由进行参数校验
  if (to.name === 'error' && (!to.query.status || !to.query.message)) {
    return { valid: false, redirect: '/main/userNodes' };
  }

  // 检查其他需要特定参数的路由
  if (to.name === 'register' && to.query.invite && !/^[a-zA-Z0-9]{6,12}$/.test(to.query.invite)) {
    return { valid: false, redirect: '/main/userNodes' };
  }

  return { valid: true };
};

// 组件加载错误处理增强
const loadComponent = (importFunc) => {
  let retryCount = 0;
  const MAX_RETRIES = 2;

  const retry = () => {
    return importFunc().catch(err => {
      if (err.name === 'ChunkLoadError' && retryCount < MAX_RETRIES) {
        retryCount++;
        return new Promise(resolve => setTimeout(() => resolve(retry()), 300));
      }
      console.error('组件加载彻底失败:', err);

      return import('@/views/homepage/AccountB.vue').then(m => {
        const ErrorComponent = m.default;
        return {
          render(h) {
            return h(ErrorComponent);
          }
        };
      });
    });
  };

  return retry;
};

// 重置路由
export function resetRouter() {
  // 清除可能的路由状态和缓存
  pendingNavigation.cancel();

  const newRouter = createRouter()
  router.matcher = newRouter.matcher

  return newRouter;
}

// 清理路由资源
const cleanupRouteResources = (path) => {
  if (window.routeCleanupHandlers && window.routeCleanupHandlers[path]) {
    try {
      window.routeCleanupHandlers[path]();
    } catch (e) {
      console.error('清理路由资源失败:', e);
    }
  }

  // 清理可能的内存泄漏
  if (window.routeComponentCache && window.routeComponentCache[path]) {
    delete window.routeComponentCache[path];
  }
};

// 统一错误处理函数 - 确保所有错误都跳转到/main/account
const handleRouterError = (error, fromRoute) => {
  console.error('路由错误:', error);
  
  // 记录错误信息用于调试
  const errorInfo = {
    message: error.message,
    name: error.name,
    stack: error.stack,
    from: fromRoute ? fromRoute.fullPath : 'unknown',
    time: new Date().toISOString()
  };
  
  // 可以选择将错误信息发送到监控系统
  // sendErrorToMonitoringSystem(errorInfo);
  
  // 无论什么错误，都导航到/main/account
  navigateToAccount();
  
  return false;
};

// 导航到账户页面 - 优化版本
const navigateToAccount = () => {
  const currentRoute = router.currentRoute;
  const targetPath = '/main/userNodes';
  
  // 检查是否已经在目标页面，避免重复导航
  if (currentRoute.path === targetPath) {
    return Promise.resolve(false);
  }

  // 使用原始方法导航到账户页
  return originalReplace.call(router, {
    path: targetPath
  }).catch(err => {
    // 即使导航失败，也不报错，保持静默
    console.warn('导航到账户页失败，但保持静默:', err);
    return false;
  });
};

// 保存原始路由方法
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

// 安全导航函数 - 防止重复导航（修复版）
const safeNavigate = (router, method, location, onComplete, onAbort) => {
  const currentPath = router.currentRoute.path
  const targetPath = typeof location === 'string' ? location : (location?.path || '')

  // 特殊处理身份认证相关页面的导航
  const authPaths = ['/main/identity'];
  
  // 如果是在认证相关页面之间导航，特殊处理
  if (authPaths.includes(currentPath) && authPaths.includes(targetPath)) {
    // 确保取消任何正在进行的导航
    pendingNavigation.cancel();
  }
  
  // 如果目标路径是account页面且当前已在该页面，直接返回成功
  if (targetPath === '/main/userNodes' && currentPath === '/main/userNodes') {
    return Promise.resolve(true)
  }
  
  // 检查是否为相同路径导航
  if (currentPath === targetPath && !pendingNavigation.isHistoryNavigation) {
    if (typeof location === 'object' && location !== null) {
      // 检查查询参数是否相同
      const currentQuery = JSON.stringify(router.currentRoute.query)
      const targetQuery = JSON.stringify(location.query || {})

      if (currentQuery === targetQuery) {
        return Promise.resolve(false)
      }
    } else {
      return Promise.resolve(false)
    }
  }

  // 检查method是否为函数
  if (typeof method !== 'function') {
    console.error('导航方法无效:', method)
    return Promise.reject(new Error('导航方法无效'))
  }

  try {
    // 使用原始方法执行导航并处理错误
    const result = method.call(router, location, onComplete, onAbort)

    // 检查结果是否有catch方法
    if (result && typeof result.catch === 'function') {
      return result.catch(err => {
        // 统一处理所有导航相关错误
        if (['NavigationDuplicated', 'NavigationCancelled', 'NavigationAborted'].includes(err.name) ||
            (err.message && (
              err.message.includes('Navigation aborted') || 
              err.message.includes('Navigation cancelled') ||
              err.message.includes('Redirected when going from')
            ))
        ) {
          pendingNavigation.finish();
          return false;
        }
        
        // 其他错误统一处理
        return handleRouterError(err, router.currentRoute);
      });
    } else {
      // 如果result不是Promise或没有catch方法，包装成Promise返回
      return Promise.resolve(result);
    }
  } catch (error) {
    console.error('导航执行出错:', error);
    pendingNavigation.finish();
    
    // 处理导航执行中的错误
    return handleRouterError(error, router.currentRoute);
  }
}

// 安全增强push方法
VueRouter.prototype.push = function(location, onComplete, onAbort) {
  const router = this

  return new Promise((resolve, reject) => {
    navigationCooldown.executeWithDelay(() => {
      safeNavigate(router, originalPush, location, onComplete, onAbort)
        .then(resolve)
        .catch(reject)
    })
  })
}

// 安全增强replace方法
VueRouter.prototype.replace = function(location, onComplete, onAbort) {
  const router = this

  return new Promise((resolve, reject) => {
    navigationCooldown.executeWithDelay(() => {
      safeNavigate(router, originalReplace, location, onComplete, onAbort)
        .then(resolve)
        .catch(reject)
    })
  })
}

// 监听浏览器历史操作
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    // 标记当前为浏览器历史导航
    pendingNavigation.isHistoryNavigation = true;

    // 重置标记
    setTimeout(() => {
      pendingNavigation.isHistoryNavigation = false;
    }, 100);
  });
  
  // 捕获所有未处理的Promise拒绝错误
  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason;
    // 检查是否为导航相关错误
    if (error && (
        error.name === 'NavigationDuplicated' || 
        error.name === 'NavigationCancelled' || 
        error.name === 'NavigationAborted' ||
        (error.message && (
          error.message.includes('Navigation aborted') ||
          error.message.includes('Navigation cancelled') ||
          error.message.includes('Redirected when going from')
        ))
    )) {
      // 阻止错误冒泡到控制台
      event.preventDefault();
    } else {
      // 非导航错误进行统一处理
      handleRouterError(error, router.currentRoute);
      event.preventDefault();
    }
  });
  
  // 捕获控制台错误
  const originalConsoleError = console.error;
  console.error = function(...args) {
    // 过滤掉Vue Router导航错误
    if (args.length > 0 && typeof args[0] === 'string') {
      const errorMsg = args[0];
      if (
        errorMsg.includes('Navigation aborted') ||
        errorMsg.includes('Navigation cancelled') ||
        errorMsg.includes('Redirected when going from') ||
        errorMsg.includes('Failed to resolve async component') ||
        errorMsg.includes('Loading chunk') ||
        errorMsg.includes('Failed to load')
      ) {
        // 静默忽略这些错误
        return;
      }
    }
    // 其他错误正常输出
    originalConsoleError.apply(console, args);
  };
}

// 全局前置守卫
router.beforeEach(async (to, from, next) => {

    // 当离开包含导出功能的页面时触发清理
  if (from.name === 'change' || from.name === 'AccountB') {
    // 通过事件总线通知所有组件关闭导出框
    if (Vue.prototype.$bus) {
      Vue.prototype.$bus.$emit('close-export-dialog');
    }
  }
  // 记录导航开始时间
  const navStartTime = Date.now();
  // console.log(to.path, from.path);
  
// store.commit('request/clearTokens')
  // 来源和目标相同，避免不必要的导航
  if (to.path === from.path &&
      JSON.stringify(to.query) === JSON.stringify(from.query) &&
      to.hash === from.hash &&
      !pendingNavigation.isHistoryNavigation) {
    return next(false);
  }

  // 开始新导航
  const navigation = pendingNavigation.start(to.path);

  // 设置页面标题
  document.title = to.meta.title || '禾动网络';

  // 路由防抖处理
  if (navigationDebounce(from.fullPath, to.fullPath) && !pendingNavigation.isHistoryNavigation) {
    pendingNavigation.finish();
    return next(false);
  }

  // 路由循环检测
  if (to.matched.length === 0) {
    pendingNavigation.finish();
    navigateToAccount();
    return next(false);
  }

  // 路由参数校验
  const validation = validateRouteParams(to);
  if (!validation.valid) {
    pendingNavigation.finish();
    return next(validation.redirect ?
      { path: validation.redirect, query: validation.query } :
      false
    );
  }

  // 清理上一个路由可能的资源
  if (from.path !== to.path) {
    cleanupRouteResources(from.path);
  }
  try {
    
    // 认证逻辑检查
    const hasToken = localStorage.getItem('token');
    const isAuthenticated = localStorage.getItem('is_auth') === '1';

    // 需要登录的页面检查
    if (to.meta.isAuth && !hasToken) {
      Vue.prototype.$message.warning('请先登录');
      pendingNavigation.finish();
      return next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }

    // 认证相关页面列表
    const authPaths = ['/main/identity'];
    
    // 需要身份认证的页面检查 - 处理认证流程中的特殊情况
    if (!isAuthenticated && 
        ![...authPaths, '/login', '/register', '/error','/main/identity','/findPassword','/door','/portal'].includes(to.path)) {

      Vue.prototype.$message.error('请先完成身份认证');
      
      // 判断是否正在进行认证流程中的页面导航
      if (authPaths.includes(from.path)) {
        // 如果是从认证流程中的页面导航到非认证页面，取消导航
        pendingNavigation.finish();
        return next(false);
      }
      
      if (to.path !== '/main/identity') {
        // 先导航到请求的页面
        next();
        
        // 使用requestAnimationFrame确保UI更新
        requestAnimationFrame(() => {
          // 检查导航是否已被取消
          if (navigation.cancelled) {
            return;
          }
          
          // 使用setTimeout避免过快导航
          setTimeout(() => {
            // 再次检查导航状态
            if (pendingNavigation.isCancelled()) {
              return;
            }
            
            // 使用原始push方法导航，避免递归调用
            originalPush.call(router, '/main/identity').catch(() => {
              // 静默处理所有导航错误
            });
          }, 100);
        });
        // router.replace('/main/identity');
        return;
      }
    }

    // 记录导航中的处理时间
    const processingTime = Date.now() - navStartTime;
    if (processingTime > 50) {
      console.warn(`导航处理耗时过长: ${processingTime}ms, 路径: ${to.path}`);
    }

    next();
  } catch (error) {
    console.error('路由守卫异常:', error);
    pendingNavigation.finish();
    navigateToAccount();
    next(false);
  }
});

// 全局后置钩子
router.afterEach((to, from) => {
  // 完成导航处理
  pendingNavigation.finish();

  // 记录性能数据
  const perfData = window.performance && window.performance.getEntriesByType
    ? window.performance.getEntriesByType('navigation')[0]
    : null;

  if (perfData) {
    const navigationTime = Math.round(perfData.domComplete - perfData.startTime);
    
    // 性能监控
    if (navigationTime > 1000) {
      console.warn(`导航耗时过长: ${navigationTime}ms, 路径: ${to.path}`);
    }
  }
});

// 全局错误监听 - 确保所有错误都跳转到/main/account
router.onError((error) => {
  // 使用统一的错误处理函数
  handleRouterError(error, router.currentRoute);
});

// 添加错误页面路由刷新保护
router.beforeResolve((to, from, next) => {
  // 处理可能的组件解析错误
  try {
    // 检查组件是否可用
    if (to.matched.some(record => !record.components || !record.components.default)) {
      console.warn('检测到路由组件可能未正确配置:', to.path);

      // 对于可能的组件问题，重定向到account页面
      if (to.meta.isAuth && !to.matched.some(record => record.components && record.components.default)) {
        console.error('路由组件未找到，重定向到account页面');
        return next('/main/homeIndex');
      }
    }
  } catch (e) {
    console.error('路由解析时出错:', e);
    return next('/main/homeIndex');
  }

  next();
});

// API请求错误处理辅助方法
export const handleApiError = async (error) => {
  // 处理网络错误
  const errorInfo = {
    status: error.response?.status || 503,
    message: error.response?.data?.message || '网络请求失败，请检查网络连接'
  };

  // 根据状态码优化错误信息
  switch (errorInfo.status) {
    case 401:
      errorInfo.message = '登录已过期，请重新登录';
      // 可以清除登录状态
      localStorage.removeItem('token');
      break;
    case 403:
      errorInfo.message = '没有权限访问此资源';
      break;
    case 404:
      errorInfo.message = '请求的资源不存在';
      break;
    case 500:
      errorInfo.message = '服务器内部错误';
      break;
  }

  // 使用辅助函数导航到account页面
  if (errorInfo.status === 401) {
           localStorage.removeItem('token')
        await router.push({
          path: '/login'
        })
        return Promise.resolve();
  }
  else if(errorInfo.status === 406){
// console.log("当前路由:", router.currentRoute.path);
      if ( router.currentRoute.path !== '/login') {
       
        try {
          alert('登录过期，请重新登录！')
          localStorage.removeItem('token')
          await router.push({
            path: '/login'
          })
          // 跳转登录后，直接返回一个 resolved 的 Promise，阻止错误继续抛出
          return Promise.resolve();
        } finally {
         
        }
      }
  }
  else{
     navigateToAccount();

  }
 
  return Promise.reject(error);
};

// 初始化时恢复上次路径（如果存在）
const initRouter = () => {
  const savedPath = sessionStorage.getItem('lastPath');
  const lastError = sessionStorage.getItem('lastError');

  // 检查是否有最近的错误
  if (lastError) {
    try {
      const errorData = JSON.parse(lastError);
      const errorTime = errorData.time;

      // 如果错误是最近5分钟内发生的，可能是刷新导致的
      if (Date.now() - errorTime < 5 * 60 * 1000) {
        
      }
      
      // 清除错误记录
      sessionStorage.removeItem('lastError');
    } catch (e) {
      console.error('解析错误数据失败:', e);
      sessionStorage.removeItem('lastError');
    }
  }

  if (savedPath && savedPath !== '/' && savedPath !== '/login') {
    sessionStorage.removeItem('lastPath');

    // 添加延迟以确保应用完全初始化
    setTimeout(() => {
      originalReplace.call(router, savedPath).catch(err => {
        if (!['NavigationDuplicated', 'NavigationCancelled', 'NavigationAborted'].includes(err.name)) {
          console.error('恢复路径失败:', err);
          // 恢复失败时导航到首页
          originalReplace.call(router, '/').catch(() => {});
        }
      });
    }, 50);
  }
};

// 挂载完成后初始化
if (typeof window !== 'undefined') {
  window.addEventListener('DOMContentLoaded', () => {
    setTimeout(initRouter, 0);
  });

  // 添加应用关闭前的保存逻辑
  window.addEventListener('beforeunload', () => {
   
    if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/') {
      try {
        sessionStorage.setItem('lastVisitedTime', Date.now().toString());
      } catch (e) {
        console.error('保存状态失败:', e);
      }
    }
  });
}

export default router